// TODO: Temporay until the protected token will be manifested in the subgraph.
export const PROTECTED_TOKENS = {
  "0xeec7f613e898e34602c10543950274958c30e77f": "0x04fa0d235c4abf4bcf4787af4cf447de572ef828"
}
